import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseConfig';

const AdminLogin = ({ isDarkMode }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin');
    } catch (err) {
      setError('არასწორი ელ-ფოსტა ან პაროლი!');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = `w-full p-3 rounded-lg border outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
    isDarkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-gray-55 border-gray-300 text-gray-900'
  }`;

  return (
    <div className={`min-h-screen flex items-center justify-center px-4 transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900' : 'bg-gray-55'
    }`}>
      
      <Helmet>
        <title>ავტორიზაცია | New Innovation Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className={`w-full max-w-md p-8 rounded-2xl shadow-xl border ${
        isDarkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-100 text-gray-900'
      }`}>
        <h2 className="text-2xl font-bold text-center mb-6">🔒 ადმინ ავტორიზაცია</h2>
        
        {error && <p className="text-red-500 text-sm text-center mb-4 font-semibold">{error}</p>}
        
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-1.5">ელ-ფოსტა</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputClass} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5">პაროლი</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={inputClass} />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={() => navigate('/')} className="w-1/3 bg-gray-500 hover:bg-gray-600 text-white p-3 rounded-lg font-bold transition-colors">
              უკან
            </button>
            <button type="submit" disabled={loading} className="w-2/3 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-lg font-bold transition-colors disabled:opacity-50">
              {loading ? 'მოწმდება...' : 'შესვლა'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;